import { getDataCellExportValue } from "components/datatable/DataCell";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx-js-style";
import { autoFitColumns, cellEmpty, cellFilter, cellFlat, cellH, cellV } from "utils/XLSUtils";

const useXLSExport = () => {
  const cellExportValue = (val, align) => {
    if (val && typeof val === "object" && val.__exportType === "link") {
      return {
        ...cellV(val.label || "Lihat", align),
        l: { Target: val.href, Tooltip: val.href },
      };
    }
    if (val && typeof val === "object" && val.__exportType === "image") {
      return val.href || val.src
        ? {
            ...cellV(val.label || "Lihat", align),
            l: { Target: val.href || val.src, Tooltip: val.href || val.src },
          }
        : cellV("", align);
    }
    return cellV(val, align);
  };

  const saveXLS = (conf) => {
    const { data, dlist, coltype, xlslist = null, title = "", filter } = conf;
    let columns = xlslist?.columns;
    columns = columns ? columns : dlist?.columns;
    const headerGroups = xlslist?.headerGroups || dlist?.headerGroups || [];
    const groupedColumns = new Set((Array.isArray(headerGroups) ? headerGroups : []).flatMap((group) => group?.columns || []));
    const filtered = dlist?.filter;

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const hasHeaderGroups = Array.isArray(headerGroups) && headerGroups.length > 0;

    const rowHeader =
      columns &&
      columns.map((col) => {
        const val = hasHeaderGroups && !groupedColumns.has(col)
          ? ""
          : col === "no"
            ? "No."
            : (coltype?.[col]?.headerLabel || coltype?.[col]?.label);
        const horizontal = coltype?.[col]?.align ? coltype[col].align : "left";
        return col in coltype && col !== "action" ? cellH(val, horizontal) : cellEmpty;
      });

    const rowHeaderGroup = hasHeaderGroups
      ? columns.map((col) => {
          if (!(col in coltype) || col === "action") {
            return cellEmpty;
          }
          const group = headerGroups.find((item) => (item?.columns || [])[0] === col);
          if (group) {
            return cellH(group.label, "center");
          }
          if (groupedColumns.has(col)) {
            return cellH("", "center");
          }
          const val = col === "no" ? "No." : coltype?.[col]?.label;
          const horizontal = coltype?.[col]?.align ? coltype[col].align : "left";
          return cellH(val, horizontal);
        })
      : null;

    let rowsData =
      data &&
      data.map((item, i) =>
        columns.map((col) => {
          const val =
            col === "no"
              ? i + 1
              : getDataCellExportValue(item[col], col, item, coltype[col], "xls");
          const horizontal = coltype?.[col]?.align ? coltype[col].align : "left";
          return col in coltype && col !== "action"
            ? cellExportValue(val, horizontal)
            : cellEmpty;
        })
      );

    rowsData = rowsData ? rowsData : [];

    const rowsFilter = cellFilter(filtered, filter);
    const rowTitle = [cellFlat(title, "left")];
    const rows = hasHeaderGroups
      ? [rowTitle, [cellEmpty], ...rowsFilter, rowHeaderGroup, rowHeader, ...rowsData]
      : [rowTitle, [cellEmpty], ...rowsFilter, rowHeader, ...rowsData];

    const ws = XLSX.utils.aoa_to_sheet(rows);
    if (hasHeaderGroups) {
      const headerRowIndex = 2 + rowsFilter.length;
      const merges = [];
      headerGroups.forEach((group) => {
        const groupColumns = (group.columns || []).filter((item) => columns.includes(item) && item in coltype && item !== "action");
        if (groupColumns.length < 1) {
          return;
        }
        const start = columns.indexOf(groupColumns[0]);
        const end = columns.indexOf(groupColumns[groupColumns.length - 1]);
        if (start >= 0 && end > start) {
          merges.push({ s: { r: headerRowIndex, c: start }, e: { r: headerRowIndex, c: end } });
        }
      });
      columns.forEach((col, idx) => {
        if (col in coltype && col !== "action" && !groupedColumns.has(col)) {
          merges.push({ s: { r: headerRowIndex, c: idx }, e: { r: headerRowIndex + 1, c: idx } });
        }
      });
      ws["!merges"] = merges;
    }
    autoFitColumns(ws);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const bdata = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(bdata, "data" + fileExtension);
  };

  return [saveXLS];
};

export default useXLSExport;
